var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Apexchart',{attrs:{"type":"radar","options":_vm.chartOptions,"series":[{ name: 'Skeleton data', data: [0, 0, 0, 0, 0] }]}})}
var staticRenderFns = []

export { render, staticRenderFns }